import { render } from "./Templates.vue?vue&type=template&id=4ed43a86&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4ed43a86"

export default script